import { hyperdbTriggers } from 'hyperdb-utils';
import httpRequest from '../../helpers/httpRequest';
import * as config from '../../../config';

const triggers = hyperdbTriggers({ config, triggerName: 'dashboard', namespace: 'DASHBOARD' });

export default {
  ...triggers,
  getDashboardMenuData(dispatch, getState) {
    dispatch({ type: 'DASHBOARD__GET_MENU_DATA', payload: location });
    return httpRequest('GET', config.APP_URL + '/dashboard/get-menu-data')
      .then(res => {
        dispatch({ type: 'DASHBOARD__GET_MENU_DATA_SUCCESSFULL', payload: res });
      })
      .catch(err => {
        dispatch({ type: 'DASHBOARD__GET_MENU_DATA_FAILED', payload: err });
      });
  },
  getOverviewData(dispatch, getState, props = {}) {
    const { selectedFilter, selectedItemId } = props;
    console.log({ selectedFilter, selectedItemId })
    dispatch({ type: 'DASHBOARD__GET_OVERVIEW_DATA', payload: location });
    return httpRequest('GET',  config.APP_URL + '/dashboard/get-overview-data'+ `?selectedFilter=${selectedFilter}&selectedItemId=${selectedItemId}`)
      .then(res => {
        dispatch({ type: 'DASHBOARD__GET_OVERVIEW_DATA_SUCCESSFULL', payload: res });
      })
      .catch(err => {
        dispatch({ type: 'DASHBOARD__GET_OVERVIEW_DATA_FAILED', payload: err });
      });
  },
};



// WEBPACK FOOTER //
// ./src/frontend/modules/dashboard/triggers.js